import { Injectable, EventEmitter } from '@angular/core'
import { CreateSurvey } from '../../../../shared/components/page/page.model';
import { BehaviorSubject, forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { SurveyModel } from '../../../../dashboard/dashboard.model';
import { SurveyAnalytics } from 'src/app/create/models/surveyAnalytics.model';
import { SurveyResponse, SurveyUserResponse } from 'src/app/create/models/serveyResponses.model';
import { WorkflowView } from 'src/app/create/models/workflowView.model';
import { WorksheetView } from 'exceljs';
import { WFStatusResult, WorkflowStepAssignedView } from 'src/app/create/models/workflowStepAssignedView.model';
import { ConditionalOperator } from 'src/app/create/models/WorkflowStepConfig.model';
import { GroupModel, UserGroupModel, UserGroupDataModel } from 'src/app/admin/models/group.model';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { Constants } from "../../../../shared/constants";
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { ParamService } from 'src/app/shared/services/param.service';
import { Router } from "@angular/router";
import { CreateEntity } from 'src/app/create/models/entity.model';
import { CreateBusinessProcessComponent } from 'src/app/create/create-business-process/create-business-process.component';
import { CreateBusinessProcessModel } from 'src/app/create/models/businessProcess.model';
import { AgencyModel } from 'src/app/shared/models/agency.model';


@Injectable({
  providedIn: 'root'
})
export class CardService {
  constant: Constants = new Constants();
  private publishSurvey = new BehaviorSubject(false);
  invokeFirstComponentFunction = new EventEmitter();
  subsVar: Subscription;
  invokeWorkflowComponentFunction = new EventEmitter();
  bpAnalyticsSurveyId = new EventEmitter<string>();
  //bpResultSurveyId = new EventEmitter<string>();
  bpResultSurveyId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  subVar: Subscription;
  private publishFlag = new BehaviorSubject(false);
  private isSurveyNotificationFlag = new BehaviorSubject(false);
  private fromDashboard = new BehaviorSubject(false);
  private routeValuePublish = new BehaviorSubject("businessProcess");
  private _userSurveySource = new BehaviorSubject(new Array());
  currentUserSurvey = this._userSurveySource.asObservable();

  private _userTeplateSource = new BehaviorSubject(new Array());
  currentUserTemplate = this._userTeplateSource.asObservable();

  private _source = new BehaviorSubject(new CreateSurvey());
  currentMessage = this._source.asObservable();

  private _templatesource = new BehaviorSubject(new CreateSurvey());
  templatecurrentMessage = this._templatesource.asObservable();

  private _tempsource = new BehaviorSubject(new CreateSurvey());
  tempdatacurrentMessage = this._tempsource.asObservable();

  private _tempResultsource = new BehaviorSubject(new CreateSurvey());
  tempdataResulltMessage = this._tempResultsource.asObservable();

  private _tempAnalyticsSource = new BehaviorSubject<SurveyAnalytics[]>([]);
  tempAnalyticsMessage = this._tempAnalyticsSource.asObservable();

  private _tempResponseSource = new BehaviorSubject(new SurveyResponse());
  tempResponseMessage = this._tempResponseSource.asObservable();

  //use this only on result page for navifating to survey main i.e take survey
  private _tempUserRespReadOnlySource = new BehaviorSubject<Boolean>(false);
  tempUserRespReadOnlyMessage = this._tempUserRespReadOnlySource.asObservable();

  private _tempUserRespSource = new BehaviorSubject(new SurveyUserResponse());
  tempUserRespMessage = this._tempUserRespSource.asObservable();

  //To hold workflow design with user mapping
  private _tempWFDetailSource = new BehaviorSubject(new WorkflowView());
  tempWFDetailMessage = this._tempWFDetailSource.asObservable();

  private _tempConditionalOpsSource = new BehaviorSubject(<ConditionalOperator[]>([]));
  _tempConditionalOpsMessage = this._tempConditionalOpsSource.asObservable();

  private _tempUserGrpDetailSource = new BehaviorSubject(<UserGroupModel[]>([]));
  _tempUserGrpDetailMessafe = this._tempUserGrpDetailSource.asObservable();

  private _tempGrpDetailSource = new BehaviorSubject(<GroupModel[]>([]));
  _tempGrpDetailMessage = this._tempGrpDetailSource.asObservable();

  //bussiness process wf
  private _tempBProcessWFDetailsSource = new BehaviorSubject(new WorkflowView());
  _tempBPWorkflowDetailsMessage = this._tempBProcessWFDetailsSource.asObservable();

  //bussiness process details
  private _tempBProcessDetails = new BehaviorSubject(new CreateBusinessProcessModel());
  _tempBProcessDetailsMessage = this._tempBProcessDetails.asObservable();

  //display info bar data
  private _tempDisplayInfoBarDetails = new BehaviorSubject(new Object());
  _tempDisplayInfoBarMessage = this._tempDisplayInfoBarDetails.asObservable();


  //bp results
  private _tempselectedTab = new BehaviorSubject(2);
  _tempselectedTabMessage = this._tempselectedTab.asObservable();


  private resetQuesDateRespSubject = new Subject<void>();
  resetDate$ = this.resetQuesDateRespSubject.asObservable();

  private resetQuesRatingRespSubject = new Subject<void>();
  resetRating$ = this.resetQuesRatingRespSubject.asObservable();
  
  private resetQueFileRespSubject = new Subject<void>();
  resetFile$ = this.resetQueFileRespSubject.asObservable();

  private _tempAgencySource = new BehaviorSubject(new AgencyModel());
  tempAgencyMessage = this._tempAgencySource.asObservable();

  getBpResultsSelectedTab(tabIndex) {
    this._tempselectedTab.next(tabIndex);
  }


  getConditionalOpertaors(condt: ConditionalOperator[]) {
    this._tempConditionalOpsSource.next(condt);
  }

  getGroupDetails(usrs: GroupModel[]) {
    this._tempGrpDetailSource.next(usrs);
  }

  getUserGroupDetails(grp: UserGroupModel[]) {
    this._tempUserGrpDetailSource.next(grp);
  }
  //To hold workflow steps details assigned to user
  private _tempWFAssignmentDetailSource = new BehaviorSubject(<WorkflowStepAssignedView[]>([]));
  tempWFAssignmentDetailMessage = this._tempWFAssignmentDetailSource.asObservable();


  private _tempWFStatus = new BehaviorSubject(<WFStatusResult[]>([]));
  tempWFStatusMessage = this._tempWFStatus.asObservable();



  constructor(private baseHttpService: BaseHttpService,
    private sessionHanlder: GlobalsessionhandlerService,
    private paramservice: ParamService,
    private router: Router) { }

  getUserResponseSurvey(response: SurveyUserResponse) {

    if (response != null && Object.keys(response).length != 0) {
    }
    this._tempUserRespSource.next(response);
  }

  getUserRespIsReadonly(IsReadOnly: boolean) {
    this._tempUserRespReadOnlySource.next(IsReadOnly);
  }
  getUserSurvey(surveyList: SurveyModel[]) {

    if (Object.keys(surveyList).length != 0) {
    }
    this._userSurveySource.next(surveyList);
  }

  getUserTemplate(templateList: SurveyModel[]) {

    if (Object.keys(templateList).length != 0) {
    }
    this._userTeplateSource.next(templateList);
  }




  getSurveyDetails(queslist: CreateSurvey) {
    if (Object.keys(queslist).length != 0) {
      if (queslist.sections != null) {
        queslist.sections = queslist.sections.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
      }
      if (queslist.sections != null) {
        queslist.sections.forEach((obj, index) => {
          if (obj.questions != null) {
            obj.questions = obj.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
          }
        });
      }


    }
    this._source.next(queslist)
  }
  //For Template
  templatesurveydata(queslist: CreateSurvey) {

    if (Object.keys(queslist).length != 0) {
      if (queslist.sections != null) {
        queslist.sections = queslist.sections.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
      }
      if (queslist.sections != null) {
        queslist.sections.forEach((obj, index) => {
          if (obj.questions != null) {
            obj.questions = obj.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
          }
        });
      }


    }
    this._templatesource.next(queslist)
  }

  tempHoldWFDetail(wf: WorkflowView) {
    this._tempWFDetailSource.next(wf);
  }
  tempHoldWFAssignmentDetail(wf: WorkflowStepAssignedView[]) {
    this._tempWFAssignmentDetailSource.next(wf);
  }

  tempHoldWfResult(wf: WFStatusResult[]) {
    this._tempWFStatus.next(wf);
  }
  tempHoldResponsedata(ques: SurveyResponse) {
    this._tempResponseSource.next(ques)
  }
  tempHoldAnalyticsdata(ques: SurveyAnalytics[]) {
    this._tempAnalyticsSource.next(ques)
  }
  tempholdSurveyResultData(queslist: CreateSurvey) {
    this._tempResultsource.next(queslist)
  }
  // For Holding Questions and Answers
  tempholdSurveyData(queslist: CreateSurvey) {

    //if (Object.keys(queslist).length != 0) {
    //  if (queslist.sections != null) {
    //    queslist.sections = queslist.sections.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
    //  }
    //  if (queslist.sections != null) {
    //    queslist.sections.forEach((obj, index) => {
    //      if (obj.questions != null) {
    //        obj.questions = obj.questions.sort((a, b) => (a.sequenceNumber > b.sequenceNumber) ? 1 : -1);
    //      }
    //    });
    //  }


    //}
    this._tempsource.next(queslist)
  }
  editSurvey(surveyId: string) {
    this.baseHttpService
      .getById(this.constant.getSurveyById, surveyId)
      .subscribe(result => {

        if (result != null) {
          this.sessionHanlder.SetESignReq(result["isESignReq"]);
          this.getSurveyDetails(result);
          this.loadWfDetails(result);
          // this.paramservice.Parameterpass("CREATE");
          // this.router.navigate(["/create"]);
        }
      });
  }
  loadWfDetails(surveyDetails: CreateSurvey) {
    let selectedOrgId = this.sessionHanlder.getOrganizationId();
    const workflow$ = this.baseHttpService.getById(this.constant.getWorkflow, surveyDetails.surveyId);
    const users$ = this.baseHttpService.getById(this.constant.getAllUsersByOrg, selectedOrgId);
    const groups$ = this.baseHttpService.get(this.constant.getAllGroups);
    const condt$ = this.baseHttpService.get(this.constant.getConditioanalOperator);

    //    if(surveyDetails.surveyId)
    //  {
    forkJoin([workflow$, users$, groups$, condt$]).subscribe(results => {
      let groups: GroupModel[] = [];
      let workflowDetails: WorkflowView = new WorkflowView();
      let conditionalOp = [];
      let users: UserGroupModel[] = [];
      let userInfo: UserGroupDataModel = new UserGroupDataModel();
      workflowDetails = results[0];
      conditionalOp = results[3];
      Object.assign(groups, results[2]);
      results[2] = results[2].filter(x => x.organizationId == selectedOrgId).map(ele => {
        ele.fullName = `${ele.groupName} (G)`;
        return ele;
      });
      users = [...results[1], ...results[2]];
      this.getGroupDetails(groups);
      this.getUserGroupDetails(users);
      this.tempHoldWFDetail(workflowDetails);
      this.getConditionalOpertaors(conditionalOp);
      this.paramservice.Parameterpass("CREATE");
      this.router.navigate(["/create"]);
    });
    // }
    // else
    // {
    //   this.paramservice.Parameterpass("CREATE");
    //   this.router.navigate(["/create"]);
    // }

  }

  getProcessWorkflowDetails(wfDetails: WorkflowView) {
    this._tempBProcessWFDetailsSource.next(wfDetails);
  }

  getProcessdetails(details: CreateBusinessProcessModel) {
    this._tempBProcessDetails.next(details);
  }
  getPublishFlag(): Observable<boolean> {
    return this.publishFlag.asObservable();
  }
  setPublishFlag(value) {
    this.publishFlag.next(value);
  }

  getIsSurveyNotificationFlag(): Observable<boolean> {
    return this.isSurveyNotificationFlag.asObservable();
  }
  setIsSurveyNotificationFlag(value) {
    this.isSurveyNotificationFlag.next(value);
  }

  getFromDashboardFlag(): Observable<boolean> 
  {
    return this.fromDashboard.asObservable();
  }
  setFromDashboardFlag(value){
    this.fromDashboard.next(value);
  }


  getrouteValuePublishFlag(): Observable<string> {
    return this.routeValuePublish.asObservable();
  }
  setrouteValuePublishFlag(flag) {
    this.routeValuePublish.next(flag);
  }


  getDisplayInfoBarDetails(details: Object) {
    this._tempDisplayInfoBarDetails.next(details);
  }
  getSurveyPublishFlag(): Observable<boolean> {
    return this.publishSurvey.asObservable();
  }
  setSurveyPublishFlag(flag) {
    this.publishSurvey.next(flag);
  }

  onPublishButtonClick() {
    this.invokeFirstComponentFunction.emit();
  }
  onPublishButtonClickWorkflow() {
    this.invokeWorkflowComponentFunction.emit();
  }

  onbpchange(val) {
    this.bpAnalyticsSurveyId.emit(val);
  }

  onbpchangeResults(val) {
    //this.bpResultSurveyId.emit(val);
    this.bpResultSurveyId.next(val);
  }


  triggerResetDateOrTime() {
    this.resetQuesDateRespSubject.next();
  }
  triggerResetRating() {
    this.resetQuesRatingRespSubject.next();
  }
  triggerResetFile() {
    this.resetQueFileRespSubject.next();
  }

  tempHoldAgencyDetails(agency: AgencyModel) {
    this._tempAgencySource.next(agency)
  }
}


